export default `
query RefrigerantTypes {
    refrigerantTypes {
        id
        uuid
        name
        position
        archived
    }
}`
